import React, { memo, useCallback, useMemo } from 'react';

import { ViewActionTableCell } from '@components/common';

import styles from './LocalIdsListCell.module.scss';

interface ILocalIdsListCellProps {
	idsList: number[];
	maxLength: number;
	onViewHandler: (idsList: number[]) => void;
}

const IDS_SEPARATOR = ' ';

const LocalIdsListCell = ({
	idsList,
	onViewHandler,
	maxLength,
}: ILocalIdsListCellProps) => {
	const isExceededMaxRange = idsList.length > maxLength;

	const preparedList = useMemo(() => {
		return isExceededMaxRange
			? idsList.slice(0, maxLength)
			: idsList;
	}, [isExceededMaxRange, idsList, maxLength]);

	const onClick = useCallback(() => {
		onViewHandler(idsList);
	}, [idsList, onViewHandler]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.listWrapper}>
				{preparedList.sort((a, b) => (a - b)).join(IDS_SEPARATOR)}
			</div>
			{
				isExceededMaxRange && (
					<ViewActionTableCell
						isDisabled={!idsList.length}
						onClick={onClick}
						text='View all'
					/>
				)
			}
		</div>
	);
};

export default memo(LocalIdsListCell);
